import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { GetMillList } from "../../api/orgs";
import { Loader } from "../../components/Loader";
import { Organisation } from "../../models/organisation/OrganisationModelV2";
import "./Companies.scss";

function Companies({ client, onViewMoreClick }) {

    const { t } = useTranslation();

    const [loading, setLoading] = useState<boolean>()

    const [companies, setCompanies] = useState<Organisation[]>([])

    const CompaniestHeader = () => {
        return <tr>
            <th>{t('name')}</th>
            <th>{t('location')}</th>
        </tr>
    }

    const CompaniestRow = (company: Organisation, onCompanyClick) => {
        return <tr className="hoverGreenPale" style={{cursor:"pointer"}} key={company.id} onClick={() => {
            onCompanyClick(company)
        }}>
            <td>{company.name}</td>
            <td>{company?.location?.village}</td>
        </tr>
    }

    useEffect(() => {
        setLoading(true)
        const fetchCompanies = () => {
            client.query({
                query: GetMillList,
            }).then(result => {
                let orgs: Organisation[] = result.data.profile?.profile?.organisations?.map(o => Organisation.build(o))
                orgs = orgs.filter(o => o.isMill())
                orgs.sort((orgA, orgB) => { return orgA.name.localeCompare(orgB.name) })
                console.log('orgs', orgs, result)
                setCompanies(orgs)
            }).finally(() => {
                setLoading(false)
            })
        }
        fetchCompanies()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
            <h1>{t('my_companies')}</h1>
            <div style={{ display: "flex", flexDirection:"row" }}>
                <table className="pem-table" style={{ flex: "1", margin: "0px 20px 0px 28px" }}>
                    <thead>
                        {CompaniestHeader()}
                    </thead>
                    <tbody>
                        {companies.map((company) => CompaniestRow(company, (company) => { onViewMoreClick(company) }))}
                    </tbody>
                </table>
            </div>
            <Loader isLoading={loading}/>
        </div>
    )
}

export default Companies